var _defs, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssets13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.41 73.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #ffd100;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 5.21px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.43,
    y1: 23.43,
    x2: 49.98,
    y2: 49.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.98,
    y1: 23.43,
    x2: 23.43,
    y2: 49.98
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.7,
    cy: 36.7,
    r: 32.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssets13);
export default __webpack_public_path__ + "static/media/SVG_assets-13.b3e02289effeec7b0c456583ace2ffda.svg";
export { ForwardRef as ReactComponent };